import type {
    CreateNoveltyCheckTaskRequest,
    CreateNoveltyCheckTaskResponse,
    DetectLanguageRequest,
    DetectLanguageResponse,
    TranslateTextRequest,
    TranslateTextResponse,
    Pic2TextRequest,
    Pic2TextResponse,
    BatchUploadImagesRequest,
    BatchUploadImagesResponse,
} from './types';

/**
 * 新颖性检索 API 接口
 * @description 提供新颖性检索相关的所有 API 调用，包括任务创建、图片上传、图片识别、语言检测和翻译等功能
 */
export interface NoveltyCheckSearchApi {
    /**
     * 创建查新任务
     * @param data 创建任务的请求参数
     * @returns 创建任务的响应数据
     */
    createNoveltyCheckTask(data: CreateNoveltyCheckTaskRequest): Promise<CreateNoveltyCheckTaskResponse>;

    /**
     * 检测输入文本的语言
     * @param data 语言检测请求参数
     * @returns 检测到的语言类型
     */
    detectLanguage(data: DetectLanguageRequest): Promise<DetectLanguageResponse>;

    /**
     * 翻译文本
     * @param data 翻译请求参数
     * @returns 翻译后的文本
     */
    translateText(data: TranslateTextRequest): Promise<TranslateTextResponse>;

    /**
     * 图片转文本
     * @param data 图片转文本请求参数
     * @returns 图片识别结果
     */
    pic2Text(data: Pic2TextRequest): Promise<Pic2TextResponse>;

    /**
     * 批量上传图片
     * @param request 批量上传请求参数
     * @returns 批量上传响应
     */
    batchUploadImages(request: BatchUploadImagesRequest): Promise<BatchUploadImagesResponse>;
}

/**
 * NoveltyCheckSearchApi 的 IOC 注入标识符
 */
export const NoveltyCheckSearchApi = Symbol('NoveltyCheckSearchApi');
